/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobOutcomeTriggerType } from "./JobOutcomeTriggerType";
import { JobOutcomeTriggerDetails } from "./JobOutcomeTriggerDetails";
export const JobOutcomeTrigger = core.serialization.undiscriminatedUnion([JobOutcomeTriggerType, JobOutcomeTriggerDetails]);
